import { useAuthStore } from '~/stores/auth'
import type { LoginResponse } from '~/types/loginResponse';

const toast = useToast()

export function useTenant() {
  const authStore = useAuthStore()

  async function selectTenant(tenantCode: string, userCredentials: any): Promise<boolean> 
  {
    swal_loading()
    authStore.unsetTenant();
    try {
      const { data, error } = await useApiFetchObject<LoginResponse>(
        '/login/setTenantUser',
        {
          method: 'POST',
          body: {
            CodeTenant: tenantCode
          }
        }
      )
      if (error.value) {
        await swal_oops(data?.value?.message || 'Error al hacer login')
        return false
      }

      if (!data?.value?.success) {
        toast.add({
          title: 'Error al intentar hacer login',
          description: data?.value?.message,
          color: 'error',
          icon: 'i-lucide-triangle-alert'
        })
        return false
      }

      const userData = data.value?.data?.user
      if (!userData.tenants || !userData.tenants[0]) {
        await swal_oops('Usuario no tiene Tenant asignado')
        return false
      }

      const { token, ...safeUser } = data.value?.data
      const selectedTenant = userData.tenants[0]
      const tenantOptions = authStore.user?.tenants;
      userData.tenants = tenantOptions;
      authStore.setUser(safeUser.user || userData) // setUser in store
      authStore.setTenant(data.value?.data, selectedTenant) // setTenant in store
      return true
    } catch (err: any) {
      toast.add({
        title: 'Error inesperado',
        description: err.message,
        color: 'error',
        icon: 'i-lucide-triangle-alert'
      })
      return false
    } finally {
      swal_close()
    }
  }

  return { selectTenant }
}
